/**
 * Navbar component.
 * Hamburger menu is triggered by $trigger ('.js-mobile-menu') element.
 *
 * Usage:
 * Call Navigation.init() to initialize the navbar functionalities.
 *
 * Methods:
 *
 * init(): initializes search and hamburger
 */

const toggleActive = require('../helpers/toggleActive');

const $html = document.querySelector('html');
const $body = document.querySelector('body');
const $navbar = document.querySelector('.js-navbar');

const search = () => {
	const $toggle = document.querySelector('.js-navbar-search-toggle');
	const $form = document.querySelector('.js-navbar-search-form');
	if (!$toggle || !$form) return;

	const $submit = $form.querySelector('.js-navbar-search-submit');
	const $cancel = $form.querySelector('.js-navbar-search-cancel');
	const $input = $form.querySelector('input');

	const toggleSearch = (close = false) => {
		close = close || $navbar.classList.contains('is-search-open');
		// If the user clicks anywhere inside js-navbar-search, that isn't inside the form, it toggles the active state
		$navbar.classList.toggle('is-search-open', !close);
		// if it now contains 'is-active', this means that
		// search form was opened by last click
		if (!close) {
			// set cursor in search field, this also triggers
			// the keyboard to appear on mobile
			$input.focus();
		}
	}

	// Toggle search state
	$toggle.addEventListener('click', () => {
		toggleSearch();
	});

	// Submit through button
	$submit.addEventListener('click', e => {
		if ($input.value.length === 0) {
			e.preventDefault();
			$input.focus();
		}
	})

	// Clear and cancel
	$cancel.addEventListener('click', () => {
		$input.value = '';
		toggleSearch(true);
	})
};

const hamburger = () => {
	const $trigger = document.querySelector('.js-mobile-menu');
	if (!$trigger) return;
	const $menu = document.querySelector(`#${$trigger.dataset.target}`);
	$trigger.addEventListener('click', e => {
		e.preventDefault();
		toggleActive($html, 'is-clipped');
		toggleActive($trigger);
		toggleActive($menu);
		$navbar.classList.toggle('has-blur');
		$trigger.setAttribute('aria-expanded', $trigger.classList.contains('is-active'));
	});
};

/**
 * Show a compacter version of the navbar depending on scroll direction.
 * If the user scrolled past the navbar-top, the navbar-top gets hidden (styled for navbar-breakpoint and up only)
 * If the scroll direction is down, 
 * - mobile: the navbar slides up slightly to create a compacter version of the navbar
 * - desktop: slides up entirely
 * if the scroll direction is up, the navbar slides back down to before state, which is either fully visible or with navbar-top hidden.
 */
let previousScroll = window.pageYOffset;
const compact = () => {
	const $navbartop = $navbar.querySelector('.navbar-top');

	const minimumChange = 100; // At least have this px scroll difference before changing state
	let prevPositionOnChange = window.pageYOffset;

	const onScroll = () => {
		if ($html.classList.contains('is-clipped')) return;
		const currentScroll = window.pageYOffset;

		const isPastNavbarTop = currentScroll > $navbartop.clientHeight;
		const scrollingDown = currentScroll > previousScroll;
		
		// Toggling the entire navbar through is-scrolling-down is delayed
		const shouldChange = (currentScroll <= prevPositionOnChange - minimumChange) || (currentScroll >= prevPositionOnChange + minimumChange);
		if (shouldChange) {
			$body.classList.toggle('is-scrolling-down', scrollingDown & isPastNavbarTop);
			prevPositionOnChange = currentScroll;
		}
		// Toggling topbar is not delayed
		$body.classList.toggle('is-hiding-topbar', isPastNavbarTop);
		previousScroll = currentScroll;
	};
	window.addEventListener('scroll', onScroll);
	// Initial
	onScroll();
};

const init = () => {
	if (!$navbar) return;
	hamburger();
	search();
	compact();
};

module.exports = init;
